import config from '../../config'

const getWorkOrderByIdRequest = ({ airportId, workOrderId }) => ({
  method: 'get',
  url: `${config.baseUrl}/${airportId}/WorkOrders/${workOrderId}`,
})

export default getWorkOrderByIdRequest
